


















import Vue from 'vue'
import {SelectValue} from '../ActiveForm/BZCore/Fields/SelectField'

export default Vue.extend({
  name: 'UiSelectInput',
  mounted () {
    if (this.selectList.length === 2 && (this.selectList[0].label === '0' || this.selectList[0].label === '1') && (this.selectList[1].label === '0' || this.selectList[1].label === '1')) {
      if (this.selectList[0].label === '0') {
        // @ts-ignore
        this.selectList[0].label = this.$t('labels.no')
      } else {
        // @ts-ignore
        this.selectList[0].label = this.$t('labels.yes')
      }

      if (this.selectList[1].label === '0') {
        // @ts-ignore
        this.selectList[1].label = this.$t('labels.no')
      } else {
        // @ts-ignore
        this.selectList[1].label = this.$t('labels.yes')
      }
    }
    if (this.selectList.length === 2 && this.selectList[0].label === 'F' && this.selectList[1].label === 'M') {
      // @ts-ignore
      this.selectList[0].label = this.$t('labels.gender_male_short');
      // @ts-ignore
      this.selectList[1].label = this.$t('labels.gender_female_short');
    }
  },
  props: {
    value: {},
    required: {
      type: Boolean,
      default: false
    },
    popperAppendToBody: {
      type: Boolean,
      default: true
    },
    multiSelect: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    selectList: {
      type: Array as () => SelectValue[],
      default: () => []
    },
    disabled: Boolean
  },
  methods: {
    onInput (event: string | number) {
      this.$emit('input', event)
    }
  },
  computed: {
    currentValue: {
      get (): any {
        if (this.multiSelect && !this.value) {
          return [];
        }
        return this.value
      },
      set () {
      }
    }
  }
})
